import Vue from "vue";
import VueRouter from "vue-router";
import Router from "./routes/routes.js";
import App from "./App";
import jQuery from "jquery";
global.jQuery = jQuery;
import "popper.js";
import "bootstrap/dist/css/bootstrap.css";
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";
import Auth from "./packages/auth/Auth.js";
import { store } from "./packages/store/store.js";
import axios from "axios";
import VueAxios from "vue-axios";
import VueSwal from "vue-swal";
import MaterialDashboard from "./material-dashboard";
import Chartist from "chartist";
import "./assets/scss/our-scss/globle.scss";
import Vue2Filters from "vue2-filters";
import moment from "moment";
import Swal from "sweetalert2";

window.Swal = Swal;
const toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 8000
});
window.toast = toast;

axios.defaults.baseURL = "https://apidev.airbuddyhub.com/api";
// axios.defaults.baseURL = "http://localhost:8000/api";

Vue.prototype.$Chartist = Chartist;

Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Auth);
Vue.use(VueAxios, axios);
Vue.use(VueSwal);
Vue.use(Vue2Filters);
Vue.use(Notifications);

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY h:mm a");
  }
});
Vue.filter("formatDate2", function(value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY");
  }
});

Router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.forAuth)) {
    if (!Vue.auth.isAuthenticated()) {
      next({
        path: "/login"
      });
    } else next();
  } else next();
});
new Vue({
  render: h => h(App),
  store: store,
  router: Router,
  data: {
    Chartist: Chartist
  }
}).$mount("#app");
